<script>
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import axios from "axios";
/**
 * People-product component
 */
export default {
  page: {
    title: "Activity",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
    DatePicker
  },
  data() {
    return {
      title: "People",
      empLoader: false,
      value: false,
      appUsageLoader: false,
      dayWiseLoader: false,
      appUsageModal : false,
      onGoingModal: false,
      selectedDate: null,
      selectedWeek: null,
      selectedMonth: null,
      selectedYear: null,
      selectedRange: null,
      people: [],
      appUsageData: [],
      dailyActivityData: new Map(),
      peopleMap: new Map(),
      selctedEmployee: {
        empId: null,
      },
      peopleProjects: [

      ],
      filterValue: null,
    }
  },
  methods: {
    selectDate(val) {
      for(var i = 0;i < this.people.length;i++) {
        this.people[i].isCollpased = true;
        this.people[i].isOpen = false;
      }
      switch(val) {
        case 1:
          this.selectedWeek = null;
          this.selectedMonth = null;
          this.selectedYear = null;
          this.selectedRange = null;
          this.getAllActivityData(this.selectedDate, val);
          break;
        case 2:
          this.selectedDate = null;
          this.selectedMonth = null;
          this.selectedYear = null;
          this.selectedRange = null;
          var dayVal = this.selectedWeek.getDay();
          this.selectedWeek.setDate(this.selectedWeek.getDate() - dayVal);
          this.getAllActivityData(this.selectedWeek, val);
          break;
        case 3:
          this.selectedDate = null;
          this.selectedWeek = null;
          this.selectedYear = null;
          this.selectedRange = null;
          this.getAllActivityData(this.selectedMonth, val);
          break;
        case 4:
          this.selectedDate = null;
          this.selectedWeek = null;
          this.selectedMonth = null;
          this.selectedRange = null;
          this.getAllActivityData(this.selectedYear, val);
          break;
        case 5:
          this.selectedDate = null;
          this.selectedWeek = null;
          this.selectedMonth = null;
          this.selectedYear = null;
          this.getAllActivityData(this.selectedRange, val);
          break;
        default:
          
      }
    },
    async getAllActivityData(date, type) {
      
      let sendData = {};
      if(type != 5) {
        var _date = new Date(date),
        mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
        day = ("0" + _date.getDate()).slice(-2);
        sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        sendData.type = type;
        sendData.endDate = '';
      } else {
       _date = new Date(date[0]),
        mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
        day = ("0" + _date.getDate()).slice(-2);
        sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        sendData.type = type;
        _date = new Date(date[1]),
        mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
        day = ("0" + _date.getDate()).slice(-2);
        sendData.endDate = [_date.getFullYear(), mnth, day].join("-");
      }
      this.empLoader = true;

      this.people.forEach(object => {
              object.activeHours = 'N.A';
              object.idleHours = 'N.A';
              object.productivity = 'N.A';
              object.isCollpased = true;
              object.loader = false;
              object.isOpen = false;
            });

       try {
        const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/people/activity",
          { params: { companyId: this.loginData.companyId, startDate: sendData.startDate, endDate: sendData.endDate, type: type, timezone: this.loginData.timeZone } }
        );
        
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            let peopleActData = response.data.data;
            for(var i = 0;i < peopleActData.length;i++) {
              let object = this.peopleMap.get(parseInt(peopleActData[i].empId));
              if(object){
                object.activeHours = peopleActData[i].activehours;
                object.idleHours = peopleActData[i].idleHours;
                object.productivity = peopleActData[i].productivity;
              }
            }
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    toggle(val) {
      return !val;
    },
    async getDayWiseData(empId) {
      let object = this.peopleMap.get(parseInt(empId));
      object.dayWise = [];
      
      object.isCollpased = !object.isCollpased;
      this.dailyActivityData = [];
      this.dayWiseLoader = true;
      let sendData = {};
      let type = 2;
      if(this.selectedRange == null) {
        let date = null;
        if(this.selectedDate != null) {
          date = this.selectedDate;
          type = 1;
        } else if(this.selectedWeek != null) {
          date = this.selectedWeek;
          type = 2;
        } else if(this.selectedMonth != null) {
          date = this.selectedMonth;
          type = 3;
        } else if(this.selectedYear != null) {
          date = this.selectedYear;
          type = 4;
        }
        var _date = new Date(date),
        mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
        day = ("0" + _date.getDate()).slice(-2);
        sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        sendData.endDate = '';
      } else {

        _date = new Date(this.selectedRange[0]),
          mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
          day = ("0" + _date.getDate()).slice(-2);
          sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        _date = new Date(this.selectedRange[1]),
          mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
          day = ("0" + _date.getDate()).slice(-2);
          sendData.endDate = [_date.getFullYear(), mnth, day].join("-");
        
        type = 5;
      }
      if(object.isCollpased) {
        this.dayWiseLoader = false;
        return;
      }
      object.loader = true;
       try {
        const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/people/activity/daily_activity",
          { params: { companyId: this.loginData.companyId,empId: empId, startDate: sendData.startDate, endDate: sendData.endDate, type: type, timezone: this.loginData.timezone } }
        );

        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            //let object = this.peopleMap.get(parseInt(empId));
            object.loader = false;
            object.dayWise = response.data.data;
          }
        }
        
      } catch (error) {
        //console.log(error);
      }
      object.isOpen = !object.isCollpased;
      this.dayWiseLoader = false;
      object.loader = false;
    },
    async getAllPeople() {
      this.empLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/employee/get_all",
          { params: { companyId: this.loginData.companyId } }
        );
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.people = response.data.data;

            this.people.forEach(object => {
              object.activeHours = 'N.A';
              object.idleHours = 'N.A';
              object.productivity = 'N.A';
              object.isCollpased = true;
              object.loader = false;
              object.isOpen = false;
              this.peopleMap.set(object.empId, object);
            });

            try {
              const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/people/activity",
                { params: { companyId: this.loginData.companyId, timezone: this.loginData.timeZone } }
              );
              
              if(response.data.success == "true") {
                if(response.data.data.length > 0) {
                  let peopleActData = response.data.data;
                  for(var i = 0;i < peopleActData.length;i++) {
                    
                    let object = this.peopleMap.get(parseInt(peopleActData[i].empId));
                    if(object){
                      object.activeHours = peopleActData[i].activehours;
                      object.idleHours = peopleActData[i].idleHours;
                      object.productivity = peopleActData[i].productivity;
                    }
                  }
                }
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    async getAppUsage(empId) {
      this.appUsageData = [];
      this.appUsageLoader = true;
      this.appUsageModal = true;
      let sendData = {};
      let type = 2;
      if(this.selectedRange == null) {
        let date = null;
        if(this.selectedDate != null) {
          date = this.selectedDate;
          type = 1;
        } else if(this.selectedWeek != null) {
          date = this.selectedWeek;
          type = 2;
        } else if(this.selectedMonth != null) {
          date = this.selectedMonth;
          type = 3;
        } else if(this.selectedYear != null) {
          date = this.selectedYear;
          type = 4;
        }
        var _date = new Date(date),
        mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
        day = ("0" + _date.getDate()).slice(-2);
        sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        sendData.endDate = '';
      } else {
        console.log(this.selectedRange[0]);
        _date = new Date(this.selectedRange[0]),
          mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
          day = ("0" + _date.getDate()).slice(-2);
          sendData.startDate = [_date.getFullYear(), mnth, day].join("-");
        _date = new Date(this.selectedRange[1]),
          mnth = ("0" + (_date.getMonth() + 1)).slice(-2),
          day = ("0" + _date.getDate()).slice(-2);
          sendData.endDate = [_date.getFullYear(), mnth, day].join("-");
        
        type = 5;
      }

       try {
        const response = await axios.get(process.env.VUE_APP_ACTIVITY_URL + "/activity_report/people/activity/app_usage",
          { params: { companyId: this.loginData.companyId,empId: empId, startDate: sendData.startDate, endDate: sendData.endDate, type: type, timezone: this.loginData.timezone } }
        );

        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.appUsageData = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.appUsageLoader = false;
    },
    exportFullCSV() {
      var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      let fileName = "activity-data.csv";
      this.convertToCSV(this.people, fields, fileName);
    },
    exportDayWiseCSV(data) {
      var fields = ["date", "activehours", "idleHours", "productivity"];
      let fileName = data.name + "-Day-Wise.csv";
      this.convertToCSV(data.dayWise, fields, fileName);
    },
    toSnakeCase(inputString) {
      return inputString.split('').map((character) => {
          if (character == character.toUpperCase()) {
              return ' ' + character;
          } else {
              return character;
          }
      })
      .join('');
    },
    async convertToCSV(data, fields, fileName) {
      const json = data;
      //var fields = Object.keys(json[0])
      //var fields = ["name", "email", "designation", "teamName", "activeHours", "idleHours", "productivity"];
      var replacer = function(key, value) { return value === null ? '' : value } 
      var csv = json.map(function(row){
        return fields.map(function(fieldName){
          return JSON.stringify(row[fieldName], replacer)
        }).join(',')
      })

      // Name, Email, Designation, Team Name, Active Hours, Idle Hours, Productivity
      for(var i = 0;i < fields.length;i++) {
        fields[i] = this.toSnakeCase(fields[i]);
        fields[i] = fields[i].charAt(0).toUpperCase() + fields[i].slice(1);
      }
      csv.unshift(fields.join(',')) // add header column
      csv = csv.join('\r\n');

      //console.log(csv);
      var exportedFilenmae = fileName;
      var blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
          var link = document.createElement("a");
          if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              var url = URL.createObjectURL(blob);
              link.setAttribute("href", url);
              link.setAttribute("download", exportedFilenmae);
              link.style.visibility = 'hidden';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
          }
      }
    },
    openTotalModal(empId) {
      this.selctedEmployee.empId = empId;
      this.totalModal = true;
      this.getAllPeopleProjects();
    },
    openOnGoingModalModal(empId) {
      this.selctedEmployee.empId = empId;
      this.onGoingModal = true;
      this.getAllPeopleProjects();
    },
  },
  created() {
    
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.selectedWeek = new Date();
    let dayVal = this.selectedWeek.getDay();
    this.selectedWeek.setDate(this.selectedWeek.getDate() - dayVal);
    this.getAllPeople();
  },
  computed: {
    searchevents: function(){
      var result = this.people;
      if (!this.filterValue)
        return result;
        
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) || event.email.toLowerCase().includes(filterValue) || event.designation.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="'Activity'" />
     <div class="row mb-1">
      <div class="col-sm-2 me-3">
        <date-picker @change="selectDate(1)" :disabled="empLoader" v-model="selectedDate" :first-day-of-week="1" lang="en" :placeholder="$t('menuitems.reports.selectDate')" confirm></date-picker>
      </div>
      <div class="col-sm-2 me-3">
        <date-picker
         v-model="selectedWeek"
          type="week"
          lang="en"
          @change="selectDate(2)"
          :disabled="empLoader"
          :first-day-of-week="1"
          confirm
          :placeholder="$t('menuitems.reports.selectWeek')"
        ></date-picker>
      </div>
      <div class="col-sm-2 me-3">
          <date-picker
            v-model="selectedMonth"
            type="month"
            lang="en"
            :disabled="empLoader"
            @change="selectDate(3)"
            confirm
            :placeholder="$t('menuitems.reports.selectMonth')"
          ></date-picker>
      </div>
      <div class="col-sm-2 me-4">
          <date-picker
            v-model="selectedYear"
            type="year"
            lang="en"
            :disabled="empLoader"
            @change="selectDate(4)"
            confirm
            :placeholder="$t('menuitems.reports.selectYear')"
          ></date-picker>
      </div>
      <div class="col-sm-3">
        <date-picker @change="selectDate(5)" :disabled="empLoader" v-model="selectedRange" range append-to-body lang="en" :placeholder="$t('menuitems.reports.customRange')" confirm></date-picker>
      </div>
    </div>
    <div class="row mt-3 mb-1">
      <div class="col-sm-4">
        <div class="search-box mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.projects.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      
      </div>
      <div class="col-sm-4">
      </div>
      <div class="col-sm-4 text-end">
          <button type="button" :disabled="empLoader" @click="exportFullCSV" class="btn btn-outline-primary down-button"><i class="bx bx-download me-2"></i> {{$t('menuitems.reports.download')}}</button>
      </div>
      <!--<div class="col-sm-6" style="margin-top : -8px;">
          <b-dropdown id="dropdown-dropleft" dropleft text="Drop-Left" variant="outline-secondary" class="m-2" checkbox-menu allow-focus>
            <template #button-content>
              <i class="bx bxs-filter-alt ps-4"></i> <span class="pe-4">Filters</span>
            </template>
            <b-dropdown-form>
              <b-form-checkbox
                  class="form-check mt-2 ms-2"
                >
                  On Time
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Delayed
                </b-form-checkbox>
                <b-form-checkbox
                  class="form-check ms-2"
                >
                  Exceeded Budget
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox><b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox>
            </b-dropdown-form>
        </b-dropdown>
      </div>-->
    </div>
      
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="is-loading">
            <div class="preloader-component" v-show="false">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <div class="card-body" style="height: calc(100vh - 325px)">
            <div class="is-loading">
              <div class="preloader-component" v-show="empLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
                <simplebar style="max-height: calc(100vh - 350px)">
                  <div class="table-responsive">
                    <table
                      class="table align-middle table-nowrap table-hovers"
                    >
                      <thead class="table-light">
                        <tr>
                          <th scope="col">{{$t('menuitems.reports.details')}}</th>
                          <th scope="col">{{$t('menuitems.reports.activeHours')}}</th>
                          <th scope="col">{{$t('menuitems.reports.idleHours')}}</th>
                          <th scope="col">{{$t('menuitems.reports.productivity')}}</th>
                          <th scope="col">{{$t('menuitems.reports.appUsage')}}</th>
                          <th scope="col">{{$t('menuitems.reports.liveActivity')}}</th>
                          <th scope="col">{{$t('menuitems.reports.expand')}}</th>
                        </tr>
                      </thead>
                      <tbody v-if="searchevents.length > 0">
                          <template v-for="(data, index) in searchevents" >
                          <tr :key="data.empId + '' + index">
                          <td>
                            {{data.name}}<br/>
                            <span class="text-secondary">{{data.email}}</span><br/>
                            <span class="text-secondary">{{data.designation}}</span>
                          </td>
                          <td>
                            {{data.activeHours}}
                          </td>
                          <td>
                            {{data.idleHours}}
                          </td>
                          <td>
                            {{data.productivity}} %
                          </td>
                          <td>
                            <span class="badge badge-soft-primary font-size-13" role="button" @click="getAppUsage(data.empId)">{{$t('menuitems.reports.view')}}</span>
                          </td>
                          <td>
                            <router-link :to="{ name: 'User Activity', params: { data: data } }" class="btn btn-link" style="color: #61b045;">{{$t('menuitems.reports.liveActivity')}} <i class="bx bx-line-chart"></i></router-link>
                          </td>
                          <td>
                            <b-button @click="getDayWiseData(data.empId)" v-b-toggle="`id-${data.empId}`" pill variant="primary" class="m-1 btn-circle"><i v-if="data.isCollpased" class="bx bx-chevron-down fs-6"></i><i v-else class="bx bx-chevron-up fs-6"></i></b-button>
                            
                          </td>
                        </tr>
                        <tr :key="data.empId">
                        <td colspan="7">
                          <b-collapse :id="`id-${data.empId}`" v-model="data.isOpen">
                          <b-card>
                            
                            <div class="is-loading">
                              <div class="preloader-component" v-show="dayWiseLoader">
                                <div class="status">
                                  <div class="spinner-chase">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-10"></div>
                                <div class="col-md-2 text-end">
                                  <button type="button" :disabled="empLoader" @click="exportDayWiseCSV(data)" class="btn btn-link">{{$t('menuitems.reports.downloadDayWise')}}</button>
                                </div>
                              </div>
                              <simplebar style="height: calc(100vh - 440px)">
                                <div class="table-responsive">
                                  <table class="table mb-0">
                                    <thead>
                                      <tr>
                                        <th>{{$t('menuitems.reports.date')}}</th>
                                        <th>{{$t('menuitems.reports.activeHours')}}</th>
                                        <th>{{$t('menuitems.reports.idleHours')}}</th>
                                        <th>{{$t('menuitems.reports.productivity')}}</th>
                                        <th>{{$t('menuitems.reports.action')}}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="object in data.dayWise" :key="object.date">
                                        <th scope="row">{{object.date}}</th>
                                        <td>{{object.activehours}}</td>
                                        <td>{{object.idleHours}}</td>
                                        <td>{{object.productivity}} %</td>
                                        <td><router-link :to="{ name: 'User Activity', params: { data: data, date: object.date } }" class="btn btn-link" >{{$t('menuitems.reports.viewDetails')}}</router-link></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </simplebar>
                            </div>
                          </b-card>
                          </b-collapse>
                        </td>
                        </tr>
                        </template>
                      </tbody>
                      <tbody v-else>
                    <div style="margin-top: 50%;margin-left: 135%;">
                      <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                    </div>
                    </tbody>
                    </table>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
      </div> 
      </div>
    </div>

     <b-modal  v-model="appUsageModal" size="xl" :title="$t('menuitems.reports.appUsage')" hide-footer>
    <div class="is-loading">
        <div class="preloader-component" v-show="appUsageLoader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <div style="height: calc(100vh - 210px)">
        <simplebar ref="current" style="max-height: calc(100vh - 210px);">
          <div class="table-responsive" style="height: calc(100vh - 210px);">
            <table class="table align-middle table-nowrap table-hover" >
              <thead class="table-light">
                <tr>
                  <th scope="col" >{{ $t('menuitems.reports.serialNo') }}</th>
                  <th scope="col" >{{ $t('menuitems.reports.applicationName') }}</th>
                  <th scope="col" >{{ $t('menuitems.reports.usage') }}</th>
                </tr>
              </thead>
              
              <tbody v-if="appUsageData.length > 0">
                  <tr v-for="(data, index) in appUsageData" :key="index">
                  <td>
                    {{index + 1}}
                  </td>
                  <td>
                    {{data.appName}}
                  </td>
                  <td>
                    {{data.usage}} %
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <div style="margin-top: 40%;margin-left: 86%;">
                  <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                </div>
              </tbody>
            </table>
          </div>
        </simplebar>
        </div>
    </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
.btn-circle {
    width: 28px;
    height: 28px;
    padding: 6px 0px;
    border-radius: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 1.42857;
}
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
@media screen and (max-width: 576px) {
  .down-button {
    width: 117px;
  }
}
@media screen and (max-width: 920px) {
  .down-button {
    margin-left: -63px;
    width: 117px;
  }
}
@media screen and (min-width: 921px) {
  .down-button {
    margin-left: -53px;
    width: 117px;
  }
}
</style>